import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { useState } from 'react';
import axios from 'axios';
import { errorHandler } from 'helpers/response-utils';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const { name, id } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
              {name}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'rewardIdentity',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Reward Identity</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { rewardIdentity } = original;
      return <>{rewardIdentity}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'points',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Reward Points</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'maximumDays',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Maximum Days</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { maximumDays } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{maximumDays}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'actions',
    cell: ({ row: { original }, table }: any) => {
      const { deleteRecord, navigateToEdit } = table.options.meta;

      const [show, setShow] = useState(false);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <Dropdown.Item onClick={() => navigateToEdit(original.id)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={handleShow} className="text-danger">
                Remove
              </Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this rule?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  deleteRecord(original.id);
                  handleClose();
                }}
              >
                Yes delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const DrinkRewardRulesTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default DrinkRewardRulesTable;
